import { ReactElement } from 'react'
import { StatsCards } from 'app/components/analytics/StatsCards'
import { StatsCardType } from 'types/StatsCardType'

/** A row of KPI cards, or a matching skeleton while loading. */
export function StatsRow({
  stats,
  isLoading,
  skeletonCount,
}: {
  stats: StatsCardType[]
  isLoading: boolean
  skeletonCount: number
}): ReactElement {
  if (!isLoading) {
    // Trim StatsCards' own vertical margins; the parent spaces the rows.
    return (
      <div className="[&>div]:my-0">
        <StatsCards stats={stats} />
      </div>
    )
  }
  return (
    <div className="grid grid-cols-2 gap-3 md:flex md:gap-4">
      {Array.from({ length: skeletonCount }).map((_, i) => (
        <div key={i} className="flex-1 animate-pulse rounded-lg border border-default bg-surface px-6 py-6">
          <div className="mb-4 h-3 w-2/3 rounded bg-surface-strong" />
          <div className="h-7 w-1/2 rounded bg-surface-strong" />
        </div>
      ))}
    </div>
  )
}
